export default __webpack_public_path__ + "static/media/thumbnail_BOWLANI_Phones1.e1487f44.png";